<template>
  <div class="product-info x-margin x-border-50" data-automation="productInfo">
    <my-head-title :title="$t('HT.accessInfo.title')"></my-head-title>
    <div class="ul-item x-padding-info">
      <my-info-item :title="$t('HT.label.imei')" :info="detailData.device_imei"></my-info-item>
      <my-info-item :title="$t('HT.label.importTime')" :info="detailData.first_call_time"></my-info-item>
    </div>
    <div class="info-content x-padding-x">
      <div class="tab" v-if="isShow == true">
        <ux-table ref="table" :showPage="false" :data="detailData.details" :total="tableData.totalSize"
          :columns="columns1" :emptyText="$t('HT.nodata')" layout="total, sizes, prev, pager, next"
        ></ux-table>
      </div>
    </div>
    <template v-if="chartOption.length">
      <line-chart  v-for="(option, index) of chartOption" :option="option" :el="'echart-wrap'+index" :index="index" @change="changeChart" />
    </template>
  </div>
</template>

<script>
import lineChart from './components/lineChart';
export default {
  components: {
    lineChart
  },
  data() {
    return {
      isShow: true,
      detailData: {},
      // 表的数据
      tableData: {
        totalSize: 0,
        list: []
      },
      columns1: [
        // 表格项
        {
          label: this.$t('HT.unbindApi.name'),
          tooltip: true,
          prop: 'product_name'
        },
        {
          label: this.$t('HT.productAll.type'),
          tooltip: true,
          prop: 'product_type'
        },
        {
          label: this.$t('HT.label.api'),
          tooltip: true,
          prop: 'api_name'
        },
        {
          label: this.$t('HT.label.todayCall'),
          tooltip: true,
          prop: 'invoke_of_day'
        },
        {
          label: this.$t('HT.label.totalCall'),
          tooltip: true,
          prop: 'invoke_of_total'
        },
      ],
      chartOption: [],
    };
  },
  mounted() {
    this.detailData = sessionStorage.getItem('deviceDetail') ? JSON.parse(sessionStorage.getItem('deviceDetail')) : {};
    if (this.detailData.details) {
      this.detailData.details.map(async ({ product_id, product_name }) => {
        let data = await this.getChartData({product_id, product_name});
        this.setChartData(data);
      });


    }
  },
  beforeRouteLeave(to, from, next){
    sessionStorage.removeItem('deviceDetail');
    next();
  },
  methods: {
    async getChartData({product_id, product_name,dateType='1',startTime='',endTime=''}) {
      let params = {
        deviceImei: this.detailData.device_imei,
        productId:product_id, productName:product_name,
        dateType,
        startTime,
        endTime,
      };
      let { data } = await this.$api.device.getDeviceReport(params);
      return data;
    },

    setChartData(data,index){
      const {product_id,product_name,statistics}=data;
      const title=product_name;
      const xAxisData=statistics.map(item=>item.date);
      const seriesData=statistics.map(item=>item.count);
      let obj={
        title,
        product_id,
        product_name,
        xAxisData,
        seriesData
      };
      if(index!==undefined){
        this.$set(this.chartOption,index,obj);
      }else{
        this.chartOption.push(obj);
      }

    },

    async changeChart({index,...rest}) {
      let data= await this.getChartData(rest);
      this.setChartData(data,index);
    },



  }
};
</script>

<style lang="scss" scoped>
.product-info {
  padding-bottom: 20px;

  .info-content {
    .api_words {
      margin: 0 0 10px 0;
    }
  }
}
</style>
